import React from 'react';
import './index.scss';

const Loading = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439 334" className="pf-loading">
      <path
        d="M219.235 212.313C258.148 96.42 350.182 64.13 430.434 64.13c35.838 148.183-67.434 269.287-211.2 269.287C95.66 285.404 41.008 114.722 142.445.828c74.121 27.824 201.395 161.047 76.79 332.59C128.14 230.37 154.952 57.56 296.995.827c61.788 67.62 98.888 249.533-77.76 332.59C76.623 333.417-29.891 213.541 8.4 64.13c74.967 0 172.673 32.524 210.836 148.183z"
        fill="none"
      />
    </svg>
  );
};

export default Loading;
